import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuPaperclip } from 'react-icons/lu';
import { parseMentionsForDisplay } from '../../utils/mentionUtils';

/**
 * A robust component to render text with beautiful, interactive @mentions
 * Now supports full names with spaces
 */
export default function MentionText({ text, className = '' }) {
  const navigate = useNavigate();
  const parts = parseMentionsForDisplay(text);
  const [validUserMap, setValidUserMap] = useState({});

  useEffect(() => {
    const validateMentions = async () => {
      const mentionParts = parts.filter((p) => p.type === 'mention');
      if (mentionParts.length === 0) return;

      const newMap = { ...validUserMap };
      for (const part of mentionParts) {
        if (newMap[part.username] !== undefined) continue;

        try {
          const { data, error } = await window.ezsite.apis.tablePage(70648, {
            PageNo: 1,
            PageSize: 1,
            Filters: [{ name: 'name', op: 'Equal', value: part.username }]
          });

          if (!error && data?.List?.[0]) {
            newMap[part.username] = data.List[0].id;
          } else {
            newMap[part.username] = null;
          }
        } catch (e) {
          newMap[part.username] = null;
        }
      }
      setValidUserMap(newMap);
    };

    validateMentions();
  }, [text]);

  const handleMentionClick = (e, username) => {
    e.preventDefault();
    e.stopPropagation();
    const userId = validUserMap[username];
    if (userId) {
      navigate(`/profile/${userId}`);
    }
  };

  // If the text is exactly "(Attachment)", we hide it to prevent redundancy
  // since attachments are rendered separately below the text.
  if (text === '(Attachment)') {
    return null;
  }

  return (
    <span className={`break-words ${className}`}>
      {parts.map((part, index) => {
        if (part.type === 'mention') {
          const userId = validUserMap[part.username];
          const isValid = userId !== null && userId !== undefined;

          return (
            <span
              key={index}
              onClick={(e) => isValid && handleMentionClick(e, part.username)}
              className={`
                inline-flex items-center px-1.5 py-0.5 rounded-md font-bold transition-all duration-200
                ${isValid ?
              'bg-blue-50 text-blue-600 cursor-pointer hover:bg-blue-100 hover:text-blue-700 shadow-sm' :
              'bg-gray-50 text-gray-500 cursor-default'}
              `}
              title={isValid ? `View @${part.username}'s profile` : `@${part.username} (User not found)`}>

              {part.content}
            </span>);

        }

        // Final fallback for normal text
        return <span key={index}>{part.content}</span>;
      })}
    </span>);

}